import { useState } from "react";
import { adminApi, formatError } from "@/lib/adminApi";

const input = "w-full min-h-[48px] rounded-xl border border-line bg-white px-4 text-base focus:outline-none focus-visible:ring-2 focus-visible:ring-honey";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 py-16">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-white border border-line p-8 space-y-5 shadow-sm" data-testid="admin-login-form">
        <img src="/images/logo-240.webp" alt="Woodia Polonez logosu" width="240" height="219" className="h-20 w-auto mx-auto" />
        <h1 className="text-3xl font-semibold text-forest text-center">Yönetim girişi</h1>
        <div className="space-y-2">
          <label htmlFor="admin-email" className="block text-sm font-semibold text-wood">E-posta</label>
          <input id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="admin-login-email-input" />
        </div>
        <div className="space-y-2">
          <label htmlFor="admin-password" className="block text-sm font-semibold text-wood">Şifre</label>
          <input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="admin-login-password-input" />
        </div>
        {error && <p role="alert" className="text-sm text-[#B42318]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="w-full min-h-[52px] rounded-full bg-forest text-cream font-semibold hover:bg-forest-dark transition-colors disabled:opacity-60" data-testid="admin-login-submit-button">
          {busy ? "Giriş yapılıyor…" : "Giriş yap"}
        </button>
      </form>
    </main>
  );
}
